var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "WhatsApp",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 50,
    height: 50,
    rx: 15,
    fill: "#25D366"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.2 16.4c-8.1 0-14.7 6.48-14.7 14.48 0 2.54.68 5.02 1.98 7.2L17.4 45.6l7.72-2a14.86 14.86 0 0 0 7.08 1.8h.02c8.1 0 14.68-6.48 14.68-14.5 0-3.87-1.53-7.5-4.32-10.24a14.7 14.7 0 0 0-10.38-4.26Zm0 26.55h-.02a12.36 12.36 0 0 1-6.28-1.7l-.45-.26-4.58 1.18 1.23-4.44-.29-.46a11.9 11.9 0 0 1-1.84-6.39c0-6.65 5.49-12.06 12.23-12.06 3.27 0 6.34 1.25 8.65 3.53a11.95 11.95 0 0 1 3.58 8.55c0 6.65-5.49 12.05-12.23 12.05Zm6.7-9.02c-.37-.18-2.18-1.06-2.52-1.18-.34-.13-.58-.18-.82.18-.25.36-.95 1.17-1.16 1.41-.21.24-.43.27-.8.09-.37-.18-1.56-.57-2.96-1.81-1.1-.96-1.84-2.16-2.05-2.52-.21-.36-.02-.56.16-.74.16-.16.37-.43.55-.64.19-.22.25-.37.37-.61.12-.24.06-.46-.03-.64-.09-.18-.82-1.94-1.13-2.66-.3-.7-.6-.61-.82-.62h-.7c-.25 0-.65.09-.98.46-.34.36-1.28 1.24-1.28 3.02s1.32 3.5 1.5 3.75c.18.24 2.6 3.9 6.3 5.46.88.38 1.56.61 2.1.78.88.28 1.68.24 2.31.15.7-.1 2.18-.88 2.49-1.72.31-.85.31-1.57.22-1.72-.09-.15-.34-.24-.71-.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.9d4eb6b9409040a0b744f23effb38eba.svg";
export { ForwardRef as ReactComponent };